import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconSwissComponent = ({ ...rest }) => {
  return (
    <SvgIcon {...rest}>
      <svg
        fill="none"
        height="60"
        viewBox="0 0 80 60"
        width="80"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="#F00000" height="60" rx="8" width="80" />
        <rect fill="#F0F0F0" height="36" width="12" x="34" y="12" />
        <rect fill="#F0F0F0" height="36" transform="rotate(-90 22 36)" width="12" x="22" y="36" />
      </svg>
    </SvgIcon>
  );
};

IconSwissComponent.displayName = 'IconSwiss';

const IconSwiss = memo(IconSwissComponent);

export default IconSwiss;
